<template>
  <div>
    <!-- 搜索框 -->
    <div class="search-bar" v-if="resultList && resultList.length > 0">
      <van-search
        v-model="searchKeyword"
        placeholder="搜索选手姓名或队伍"
        show-action
        @search="onSearch"
      >
        <template #action>
          <div @click="onSearch" class="search-button">搜索</div>
        </template>
      </van-search>
    </div>

    <div v-for="(item, index) in resultList" :key="index">
      <div
        style="text-align: center;font-size: 16px;font-weight: 600;margin-top: 15px;margin-bottom : 15px;padding: 6px;background: #666;color: #fff;"
      >
        {{ item.XMQC + "（" + item.ZHID + "组）" }}
      </div>
      <table class="xhsTableClass">
        <tr>
          <td>{{ item.ZHID }}组</td>
          <td v-for="(fzItem, fzIndex) in item.FZDATALIST" :key="fzIndex">
            {{ fzItem.ZNWZH }}
          </td>
        </tr>
        <tr
          v-for="(fzItem, fzIndex) in item.FZDATALIST"
          :key="fzIndex"
          :ref="'row-' + index + '-' + fzIndex"
          :class="{ 'highlight-row': isHighlighted(index, fzIndex) }"
        >
          <td>
            <div>{{ fzItem.ZNWZH }}</div>
            <div>{{ fzItem.RYXM }}</div>
            <div v-if="fzItem.SSLXTYPE !== 'T'">{{ fzItem.DWJC }}</div>
          </td>
          <td
            v-for="(dataItem, dataIndex) in fzItem.WZSDATALIST"
            :key="dataIndex"
            v-bind:style="{
              background: dataItem.ISZT === 'COLOR' ? '#ddd' : '#fff'
            }"
            @click="jumpMxHandler(dataItem.CCH)"
          >
            <div v-html="dataItem.DATA"></div>
          </td>
        </tr>
      </table>

      <table
        class="xhsTableClass"
        style="margin-top:25px"
        v-if="queryType === 'CJC'"
      >
        <tr>
          <td>
            名次
          </td>
          <td>
            人/队名
          </td>
          <td>
            胜次
          </td>
          <td>
            {{ pmms === "SF-SUMMARK" ? "净胜场/净胜局" : "净胜场/净胜局" }}
          </td>
          <td>
            {{ pmms === "SF-SUMMARK" ? "总得分" : "净胜分" }}
          </td>
        </tr>
        <tr
          v-for="(mcItem, mcIndex) in item.MCLIST"
          :key="mcIndex"
          :ref="'mc-row-' + index + '-' + mcIndex"
          :class="{ 'highlight-row': isHighlightedMc(index, mcIndex) }"
        >
          <td>
            {{ mcItem.MCDATA }}
          </td>
          <td>
            {{
              mcItem.RYXM1 +
                (mcItem.RYXM2.length > 0 ? "/" + mcItem.RYXM2 : "") +
                (mcItem.RYXM_FIN.length > 0 ? "/" + mcItem.RYXM_FIN : "")
            }}
          </td>
          <td>
            {{ mcItem.SC }}
          </td>
          <td>
            {{ mcItem.VICSCHANG
            }}{{ mcItem.SSLX.substr(1, 2) !== "T" ? "" : "/" + mcItem.VICSJ }}
          </td>
          <td>
            {{ pmms === "SF-SUMMARK" ? mcItem.MARK : mcItem.VICMARK }}
          </td>
        </tr>
      </table>
    </div>
  </div>
</template>

<script>
export default {
  name: "XhsViewCom",
  components: {},
  props: {
    queryType: {
      type: String,
      default: ""
    },
    resultList: {
      type: Array,
      default: null
    },
    pmms: {
      type: String,
      default: ""
    },
    ssid: {
      type: String,
      default: ""
    }
  },
  data() {
    return {
      searchKeyword: "", // 搜索关键词
      highlightedRow: null // 高亮的行 {index, fzIndex}
    };
  },
  methods: {
    jumpMxHandler(CCH) {
      if (CCH === undefined || CCH.length === 0) {
        return;
      }
      this.$router.push({
        path: "/ssbfIndex",
        query: { ssid: this.ssid, jmdparam: CCH }
      });
    },
    // 判断是否高亮（分组数据行）
    isHighlighted(index, fzIndex) {
      return (
        this.highlightedRow &&
        this.highlightedRow.type === "fz" &&
        this.highlightedRow.index === index &&
        this.highlightedRow.fzIndex === fzIndex
      );
    },
    // 判断是否高亮（名次列表行）
    isHighlightedMc(index, mcIndex) {
      return (
        this.highlightedRow &&
        this.highlightedRow.type === "mc" &&
        this.highlightedRow.index === index &&
        this.highlightedRow.mcIndex === mcIndex
      );
    },
    // 搜索功能
    onSearch() {
      if (!this.searchKeyword || this.searchKeyword.trim() === "") {
        this.$toast("请输入搜索关键词");
        return;
      }

      const keyword = this.searchKeyword.trim().toLowerCase();
      let found = false;

      // 遍历所有数据查找匹配项
      for (let index = 0; index < this.resultList.length; index++) {
        const item = this.resultList[index];

        // 搜索分组数据列表
        if (item.FZDATALIST) {
          for (let fzIndex = 0; fzIndex < item.FZDATALIST.length; fzIndex++) {
            const fzItem = item.FZDATALIST[fzIndex];
            const ryxm = (fzItem.RYXM || "").toLowerCase();
            const dwjc = (fzItem.DWJC || "").toLowerCase();

            if (ryxm.includes(keyword) || dwjc.includes(keyword)) {
              found = true;
              this.highlightedRow = { type: "fz", index, fzIndex };

              // 滚动到目标位置
              this.$nextTick(() => {
                const refName = "row-" + index + "-" + fzIndex;
                const targetRow = this.$refs[refName];
                if (targetRow && targetRow[0]) {
                  targetRow[0].scrollIntoView({
                    behavior: "smooth",
                    block: "center"
                  });

                  // 3秒后取消高亮
                  setTimeout(() => {
                    this.highlightedRow = null;
                  }, 3000);
                }
              });
              return;
            }
          }
        }

        // 搜索名次列表
        if (item.MCLIST && this.queryType === "CJC") {
          for (let mcIndex = 0; mcIndex < item.MCLIST.length; mcIndex++) {
            const mcItem = item.MCLIST[mcIndex];
            const ryxm1 = (mcItem.RYXM1 || "").toLowerCase();
            const ryxm2 = (mcItem.RYXM2 || "").toLowerCase();

            if (ryxm1.includes(keyword) || ryxm2.includes(keyword)) {
              found = true;
              this.highlightedRow = { type: "mc", index, mcIndex };

              // 滚动到目标位置
              this.$nextTick(() => {
                const refName = "mc-row-" + index + "-" + mcIndex;
                const targetRow = this.$refs[refName];
                if (targetRow && targetRow[0]) {
                  targetRow[0].scrollIntoView({
                    behavior: "smooth",
                    block: "center"
                  });

                  // 3秒后取消高亮
                  setTimeout(() => {
                    this.highlightedRow = null;
                  }, 3000);
                }
              });
              return;
            }
          }
        }
      }

      // 未找到匹配项
      if (!found) {
        this.$toast("未找到匹配的选手或队伍");
        this.highlightedRow = null;
      }
    }
  }
};
</script>
<style lang="scss" scoped>
/* 搜索栏样式 */
.search-bar {
  margin: 12px;
  background: #fff;
  border-radius: 16px;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.06);
  overflow: hidden;

  /deep/ .van-search {
    padding: 0px;
  }

  /deep/ .van-search__content {
    background: #fff;
    border-radius: 12px;
    padding-left: 12px;
  }

  /deep/ .van-field__left-icon {
    color: #185f9b;
  }

  /deep/ .van-cell {
    padding: 8px 0;
  }
}

.search-button {
  padding: 0px 16px;
  background: linear-gradient(135deg, #185f9b 0%, #1a6ba8 100%);
  color: #fff;
  border-radius: 12px;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.3s ease;
  box-shadow: 0 2px 8px rgba(24, 95, 155, 0.3);

  &:active {
    transform: scale(0.95);
    box-shadow: 0 1px 4px rgba(24, 95, 155, 0.3);
  }
}

.xhsTableClass {
  background: #fff;
  width: 100%;
  border-collapse: collapse;
}

.xhsTableClass td {
  width: 100px;
  text-align: center;
  border: 1px solid #ddd;
  padding: 10px;
  font-size: 13px;
}

/* 高亮行 */
.highlight-row {
  background: linear-gradient(135deg, #fff3cd 0%, #ffe8a1 100%) !important;
  animation: highlightPulse 1.5s ease-in-out;
}

.highlight-row td {
  background: linear-gradient(135deg, #fff3cd 0%, #ffe8a1 100%) !important;
  box-shadow: inset 0 0 0 2px #ffc107;
}

@keyframes highlightPulse {
  0%,
  100% {
    opacity: 1;
  }
  50% {
    opacity: 0.8;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/commonCom/XhsViewCom.vue